import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid2,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const laPaz = [
  { day: "Miércoles", hour: "8:00", date: "1 de abril" },
  { day: "Viernes", hour: "8:00", date: "1 de mayo" },
  { day: "Miércoles", hour: "8:00", date: "3 de junio" },
  { day: "Viernes", hour: "11:00", date: "10 de junio " },
  { day: "Miércoles", hour: "8:00", date: "1 de julio" },
  { day: "Sábado", hour: "08:00", date: "1 de agosto" },
  { day: "Miércoles", hour: "08:00", date: "2 de septiembre" },
  { day: "Sábado", hour: "8:00", date: "3 de octubre " },
  { day: "Miércoles", hour: "08:00", date: "4 de noviembre " },
  { day: "Sábado", hour: "11:00", date: "7 de noviembre" },
];

const santaCruz = [
  { date: "28 de marzo", hour: "8:30", availability: "Sábado" },
  { date: "4 de abril", hour: "8:30", availability: "Sábado" },
  { date: "11 de abril", hour: "8:30", availability: "Sábado" },
  { date: "25 de abril", hour: "8:30", availability: "Sábado" },
  { date: "2 de mayo", hour: "8:30", availability: "Sábado" },
  { date: "9 de mayo", hour: "8:30", availability: "Sábado" },
  { date: "16 de mayo", hour: "8:30", availability: "Sábado" },
  { date: "23 de mayo", hour: "8:30", availability: "Sábado" },
  { date: "30 de mayo", hour: "8:30", availability: "Sábado" },
  { date: "6 de junio", hour: "8:30", availability: "Sábado" },
  { date: "13 de junio", hour: "8:30", availability: "Sábado" },
  { date: "20 de junio", hour: "8:30", availability: "Sábado" },
  { date: "27 de junio", hour: "8:30", availability: "Sábado" },
  { date: "1 de agosto", hour: "8:00", availability: "Sábado" },
  { date: "15 de agosto", hour: "8:00", availability: "Sábado" },
  { date: "18 de agosto", hour: "8:00", availability: "Martes " },
  { date: "29 de agosto", hour: "8:00", availability: "Sábado" },
  { date: "5 de septiembre", hour: "8:00", availability: "Sábado" },
  { date: "19 de septiembre", hour: "8:00", availability: "Sábado" },
  { date: "3 de octubre", hour: "8:00", availability: "Sábado" },
  { date: "17 de octubre", hour: "8:00", availability: "Sábado" },
  { date: "20 de octubre", hour: "8:00", availability: "Martes" },
  { date: "24 de octubre", hour: "8:00", availability: "Sábado" },
  { date: "7 de noviembre", hour: "8:00", availability: "Sábado" },
  { date: "21 de noviembre", hour: "08:00", availability: "Sábado" },
  { date: "5 de diciembre", hour: "08:00", availability: "Sábado" },
  { date: "12 de diciembre", hour: "08:00", availability: "Sábado" },
];

const cochabamba = [
  { date: "9 de mayo", hour: "11:30", availability: "Sábado" },
  { date: "13 de mayo", hour: "8:30", availability: "Miércoles" },
  { date: "6 de junio", hour: "11:30", availability: "Sábado" },
  { date: "10 de junio", hour: "8:30", availability: "Miércoles" },
  { date: "5 de agosto", hour: "8:30", availability: "Miércoles" },
  { date: "8 de agosto", hour: "11:30", availability: "Sábado" },
  { date: "9 de septiembre", hour: "8:30", availability: "Miércoles" },
  { date: "11 de noviembre", hour: "11:30", availability: "Sábado" },
  { date: "9 de diciembre", hour: "11:30", availability: "Miércoles" },
  { date: "26 de diciembre", hour: "8:30", availability: "Sábado" },
  { date: "26 de diciembre", hour: "11:30", availability: "Sábado" },
];

function Test() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <div>
      <Box sx={{ padding: "15px 0 15px 0" }}></Box>
      <Box sx={{ padding: "15px 0 15px 0" }}>
        <Box sx={{ width: "100%", padding: "15px 0" }}>
          <Box p={3} sx={{ fontWeight: "bold" }}>
            NUESTRAS SUCURSALES
          </Box>
          <Box
            sx={{
              background: "#009999",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
            >
              <Tab
                label="LA PAZ"
                {...a11yProps(0)}
                sx={{
                  color: "#d1d1d1",
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              />
              <Tab
                label="SANTA CRUZ"
                {...a11yProps(1)}
                sx={{
                  color: "#d1d1d1",
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              />
              <Tab
                label="COCHABAMBA"
                {...a11yProps(2)}
                sx={{
                  color: "#d1d1d1",
                  fontWeight: "bold",
                  fontSize: "18px",
                }}
              />
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "45px 0 15px 0",
              }}
            >
              <Typography sx={{ fontWeight: "bold" }}>
                SUCURSAL LA PAZ
              </Typography>
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <b>DIA</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>FECHA</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>HORA</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {laPaz.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.day}</TableCell>
                      <TableCell align="center">{row.date}</TableCell>
                      <TableCell align="center">{row.hour}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "45px 0 15px 0",
              }}
            >
              <Typography sx={{ fontWeight: "bold" }}>
                SUCURSAL SANTA CRUZ
              </Typography>
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <b>DIA</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>FECHA</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>HORA</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {santaCruz.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.availability}</TableCell>
                      <TableCell align="center">{row.date}</TableCell>
                      <TableCell align="center">{row.hour}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                padding: "45px 0 15px 0",
              }}
            >
              <Typography sx={{ fontWeight: "bold" }}>
                SUCURSAL COCHABAMBA
              </Typography>
            </Box>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <b>DIA</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>FECHA</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>HORA</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {cochabamba.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{row.availability}</TableCell>
                      <TableCell align="center">{row.date}</TableCell>
                      <TableCell align="center">{row.hour}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CustomTabPanel>
        </Box>
      </Box>
    </div>
  );
}

export default Test;
